import {initializeApp} from 'firebase/app';

// vue.config.js resolves firebaseConfig to firebaseConfig.js, which CI writes
// per environment, and falls back to the public DEV example only without it.
import firebaseConfig from 'firebaseConfig';

const FirebaseApp = initializeApp(firebaseConfig);

export {FirebaseApp};
